<script>
import LandingLayout from '@/Shared/LandingLayout.vue';
import LandingContactSection from '../../Landing/LandingContactSection.vue';
import { IconBrandLinkedin, IconBrandTwitterFilled } from '@tabler/icons-vue';

export default {
    props: {
        meta: Object,
    },
    components: {
        LandingContactSection,
        IconBrandTwitterFilled,
        IconBrandLinkedin,
    },
    layout: LandingLayout,
    mounted() {
        this.$i18n.locale = this.meta.locale;
    },
};
</script>
<template>
    <div>
        <div class="text-5xl font-bold text-center mt-5 md:mt-16">
            {{ $t('landing.about.title') }}
        </div>
        <div class="lg:mx-auto lg:max-w-5xl lg:px-8 mt-5">
            <div class="grid grid-cols-3 gap-8">
                <div>
                    <img
                        class="h-full"
                        src="/img/landing/photo-1424115087662-5845efc6b366-removebg-preview.png"
                        alt=""
                    />
                    <!--                    <img-->
                    <!--                        src="https://images.unsplash.com/photo-1424115087662-5845efc6b366?q=80&w=1976&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"-->
                    <!--                        alt=""-->
                    <!--                    />-->
                </div>
                <div class="col-span-2">
                    <p class="whitespace-pre-line" v-html="$t('landing.about.description')"></p>
                </div>
            </div>
        </div>

        <div class="">
            <div class="lg:mx-auto lg:max-w-4xl lg:px-8">
                <div class="flex justify-center my-6">
                    <span class="font-semibold text-2xl text-blue-500">{{ $t('landing.about.section2.title') }}</span>
                </div>
                <div>
                    <p class="">{{ $t('landing.about.section2.description') }}</p>
                </div>
            </div>
        </div>

        <div class="mt-16">
            <div class="bg-gray-900 py-12 sm:py-16">
                <div class="mx-auto max-w-7xl px-6 text-center lg:px-8">
                    <div class="mx-auto max-w-2xl">
                        <h2 class="text-3xl font-bold tracking-tight text-white sm:text-4xl">
                            {{ $t('messages.our_team') }}
                        </h2>
                        <p class="mt-4 text-lg leading-8 text-gray-400">
                            {{ $t('messages.out_team_slogan') }}
                        </p>
                    </div>
                    <ul
                        role="list"
                        class="mx-auto mt-10 grid max-w-2xl grid-cols-1 gap-6 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-3 lg:gap-8"
                    >
                        <li class="rounded-2xl bg-gray-800 px-8 py-10">
                            <img
                                class="mx-auto h-48 w-48 rounded-full md:h-56 md:w-56"
                                src="/img/landing/inaki.jpeg"
                                alt=""
                            />
                            <h3 class="mt-6 text-base font-semibold leading-7 tracking-tight text-white">
                                Iñaki Ibargoyen
                            </h3>
                            <p class="text-sm leading-6 text-gray-400">Diseñador</p>
                            <ul role="list" class="mt-6 flex justify-center gap-x-6">
                                <li>
                                    <a href="https://twitter.com/iiv_docente" class="text-gray-400 hover:text-gray-300">
                                        <span class="sr-only">X</span>
                                        <IconBrandTwitterFilled class="h-5 w-5" />
                                    </a>
                                </li>
                            </ul>
                        </li>
                        <li class="rounded-2xl bg-gray-800 px-8 py-10">
                            <img
                                class="mx-auto h-48 w-48 rounded-full md:h-56 md:w-56"
                                src="/img/landing/matias.jpg"
                                alt=""
                            />
                            <h3 class="mt-6 text-base font-semibold leading-7 tracking-tight text-white">
                                Matias Ibargoyen
                            </h3>
                            <p class="text-sm leading-6 text-gray-400">Desarrollador</p>
                            <ul role="list" class="mt-6 flex justify-center gap-x-6"></ul>
                        </li>
                        <li class="rounded-2xl bg-gray-800 px-8 py-10">
                            <img
                                class="mx-auto h-48 w-48 rounded-full md:h-56 md:w-56"
                                src="/img/landing/dani_.jpg"
                                alt=""
                            />
                            <h3 class="mt-6 text-base font-semibold leading-7 tracking-tight text-white">
                                Dani M. Valdivieso
                            </h3>
                            <p class="text-sm leading-6 text-gray-400">Diseñador</p>
                            <ul role="list" class="mt-6 flex justify-center gap-x-6">
                                <li>
                                    <a
                                        href="https://es.linkedin.com/in/daniel-mart%C3%ADnez-valdivieso-147a7668"
                                        class="text-gray-400 hover:text-gray-300"
                                    >
                                        <span class="sr-only">LinkedIn</span>
                                        <IconBrandLinkedin class="h-5 w-5" />
                                    </a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <!--    contact-->
        <LandingContactSection />
    </div>
</template>
